import MakeupV3KioskStudio from './MakeupV3KioskStudio';

export default MakeupV3KioskStudio;
